import { useRouter } from 'vue-router';

import { usePermissionsStore } from '@/stores';

export const useCheckPermission = () => {
  const permissionsStore = usePermissionsStore();
  const router = useRouter();

  const can = (permission: string) => {
    return permissionsStore.hasPermission(permission);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const routeCache = new Map<string, any>();

  const canAccessRoute = (to: string) => {
    let route = routeCache.get(to);
    if (!route) {
      route = router.resolve(to);
      routeCache.set(to, route);
    }

    if (route.meta?.permission) {
      return permissionsStore.hasPermission(route.meta.permission as string);
    }
    return true;
  };

  return {
    can,
    canAccessRoute,
  };
};
